import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface UnconfiguredAdAccount {
  id: string;
  ad_account_id: string;
  ad_account_name: string;
  currency: string | null;
  timezone: string | null;
  setup_status: string;
}

export function useUnconfiguredAccounts() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["unconfigured-accounts", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("ad_accounts")
        .select("id, ad_account_id, ad_account_name, currency, timezone, setup_status")
        .eq("user_id", user!.id)
        .neq("setup_status", "completed");

      if (error) throw error;
      return (data ?? []) as UnconfiguredAdAccount[];
    },
    enabled: !!user?.id,
    staleTime: 30 * 1000,
  });
}
